



















































import Vue from 'vue'
import Prism from 'vue-prism-component'
import { sendXPathRequest } from '@/core/api/xpath-request'

export default Vue.extend({
  components: {
    Prism,
  },
  data: () => ({
    loading: false,
    url: '',
    xpath: '',
    errors: {},
    response: null as any,
  }),
  methods: {
    send() {
      this.loading = true
      sendXPathRequest(this)
        .then(r => {
          this.$toastSuccess.fire()
          this.response = r.data
        })
        .catch(r => {
          this.$toastError.fire()
          this.errors = r.response?.data ?? {}
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
